import { useEffect } from 'react';
import { FilePenLine } from 'lucide-react';
import { Link } from '../router';
import { TOOLS } from '../tools/registry';
import { ROUTES } from '../routes';
import SiteFooter from '../tools/SiteFooter';
import '../tools/tools.css';

export default function Home() {
  useEffect(() => {
    document.title = 'PDF Tools - FreeAppBuilder';
  }, []);

  return (
    <div className="app-shell">
      <header className="topbar">
        <Link to="/" className="brand">
          <span className="brand-mark"><FilePenLine size={20} /></span>
          <span>PDF Tools</span>
        </Link>
      </header>
      <main className="hub">
        <section className="hub-hero">
          <p className="eyebrow">PRIVATE, IN-BROWSER TOOLS</p>
          <h1>Every PDF tool.<br /><em>None of the uploads.</em></h1>
          <p className="lede">
            Edit, compress, convert, sign and protect PDFs. These tools run in your browser tab, so your files are never uploaded.
          </p>
        </section>
        <section className="tool-grid" aria-label="PDF tools">
          {TOOLS.map((tool) => {
            const Icon = tool.icon;
            const ready = Boolean(ROUTES[tool.path]);
            const body = (
              <>
                {tool.badge && <span className="tool-badge">{tool.badge}</span>}
                {!ready && <span className="tool-badge soon">Soon</span>}
                <span className="tool-icon"><Icon size={22} /></span>
                <h2>{tool.title}</h2>
                <p>{tool.description}</p>
              </>
            );
            const style = { ['--accent' as string]: tool.accent };
            return ready ? (
              <Link key={tool.id} to={tool.path} className="tool-card" style={style}>{body}</Link>
            ) : (
              <div key={tool.id} className="tool-card disabled" style={style} aria-disabled="true">{body}</div>
            );
          })}
        </section>
        <p className="hub-note">
          Optional AI features inside Edit PDF (rewrite, chat, form fill) send the extracted text to Cloudflare Workers AI. Every other tool stays entirely in your browser.
        </p>
      </main>
      <SiteFooter />
    </div>
  );
}
